import { Injectable } from '@angular/core';
import { CommonHttpService } from '@app/core/services/common-http.service';
import { Observable } from 'rxjs';
import { PaginationModel } from '@app/models/query-models';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LoadService {
  private route = 'solodriver/load/'  

  constructor(
    private commonHttpService: CommonHttpService,
  ) { }
  

  public getLoads(argPaginationModel: PaginationModel = null):Observable<any>{
    let  params = new HttpParams();
    params= params.append('pageNumber', `${argPaginationModel.pageNumber+1}`).set('pageSize', `${argPaginationModel.recordCount}`).set('sortBy', `${argPaginationModel.sortBy}`).set('orderBy', `${argPaginationModel.orderBy}`).set('searchKeyword', `${`${argPaginationModel.searchKeyword}`}`);
    return this.commonHttpService.get<any>(`${this.route}open`,params)
   }

  public getLoad(argLoadId:any):Observable<any>{
    return this.commonHttpService.get<any>(`${this.route}open/detail?loadId=${argLoadId}`)
  }

  public applyBid(argBidModel:any):Observable<any>{
    return this.commonHttpService.post<any, any>(`${this.route}apply`, argBidModel)
  }

  public getHired(argModel:any):Observable<any>{
    const hired = 'get-hired';
    return this.commonHttpService.post<any, any>(`${this.route}${hired}`, argModel);
  }

  public assignRfpDriver(argModel:any):Observable<any>{
    const hired = 'update-truck-driver-trailer';
    return this.commonHttpService.post<any, any>(`${this.route}${hired}`, argModel);
  }

  public getActiveLoads(argPaginationModel: PaginationModel = null):Observable<any>{
    const activeLoads = 'active-loads'
    let params = new HttpParams();
    params = params.append('pageNumber', `${argPaginationModel.pageNumber+1}`).set('pageSize', `${argPaginationModel.recordCount}`);
    return this.commonHttpService.get<any>(`${'solodriver/'}${activeLoads}`,params)
  }

  public getActiveLoad(argLoadId: string): Observable<any> {
    const activeLoad  = 'active/detail'
    return this.commonHttpService.get<any>(`${this.route}${activeLoad}?loadId=${argLoadId}`)

  }

  public getAppliedBidsList(argPaginationModel: PaginationModel = null):Observable<any>{
    const appliedBids = 'applied-bids'
    let params = new HttpParams();
    params = params.append('pageNumber', `${argPaginationModel.pageNumber+1}`).set('pageSize', `${argPaginationModel.recordCount}`).set('sortBy', `${argPaginationModel.sortBy}`).set('orderBy', `${argPaginationModel.orderBy}`).set('searchKeyword', `${`${argPaginationModel.searchKeyword}`}`);
    return this.commonHttpService.get<any>(`${this.route}${appliedBids}`,params)
  }

  public getInvitations(argPaginationModel: PaginationModel = null):Observable<any>{
    const invitations = 'invitations'
    let params = new HttpParams();
    params = params.append('pageNumber', `${argPaginationModel.pageNumber+1}`).set('pageSize', `${argPaginationModel.recordCount}`).set('sortBy', `${argPaginationModel.sortBy}`).set('orderBy', `${argPaginationModel.orderBy}`).set('searchKeyword', `${`${argPaginationModel.searchKeyword}`}`);
    return this.commonHttpService.get<any>(`${this.route}${invitations}`,params)
  }

  public editBid(argBidModel:any): Observable<any> {
    const editBid = 'edit-bid'
    return this.commonHttpService.put(`${this.route}${editBid}` , argBidModel);
  }

  public withdrawBid(argBid:any): Observable<any> {
    const withdrawBid = 'withdraw-bid'
    return this.commonHttpService.put(`${this.route}${withdrawBid}/${argBid.bidId}` , argBid);
  }

  public acceptDeclineInvitation(argInvitationAcceptDecline:any):Observable<any>{
    const acceptOrDecline = 'invitations/accept-or-decline'
    return this.commonHttpService.post<any, any>(`${this.route}${acceptOrDecline}`, argInvitationAcceptDecline)
  }
  public getCanclledList(argPaginationModel: PaginationModel = null): Observable<any> {
    let params:any = new HttpParams();
    params = params.append('pageNumber', `${argPaginationModel.pageNumber + 1}`).set('pageSize', `${argPaginationModel.recordCount}`).set('sortBy', `${argPaginationModel.sortBy}`).set('orderBy', `${argPaginationModel.orderBy}`).set('searchKeyword', `${`${argPaginationModel.searchKeyword}`}`);
    return this.commonHttpService.get<any>(`${this.route}canceled`, params);
  }
  public getCanceledLoadDetail(argLoadId: string): Observable<any> {
    return this.commonHttpService.get<any>(`${this.route}canceled/${argLoadId}`);
  }
    public getOpCalendar(month: number, year: number, daysInMonth: number): Observable<any> {
    const endpoint = 'calendar';
    const params = new HttpParams()
    .set('month', month.toString())
    .set('year', year.toString())
    .set('daysInMonth', daysInMonth.toString());

  return this.commonHttpService.get<any>(`${this.route}${endpoint}`,  params );
}
  public getFinancialReporting(filters: any): Observable<any> {
    let params = new HttpParams();
    if (filters.timePeriod)          params = params.set('timePeriod',          filters.timePeriod);
    if (filters.startDate)           params = params.set('startDate',           filters.startDate);
    if (filters.endDate)             params = params.set('endDate',             filters.endDate);
    if (filters.accessorialPageNumber) params = params.set('accessorialPageNumber', String(filters.accessorialPageNumber));
    if (filters.accessorialPageSize)   params = params.set('accessorialPageSize',   String(filters.accessorialPageSize));
    if (filters.addOnChargePageNumber) params = params.set('addOnChargePageNumber', String(filters.addOnChargePageNumber));
    if (filters.addOnChargePageSize)   params = params.set('addOnChargePageSize',   String(filters.addOnChargePageSize));
    if (filters.expensePageNumber)   params = params.set('expensePageNumber',   String(filters.expensePageNumber));
    if (filters.expensePageSize)     params = params.set('expensePageSize',     String(filters.expensePageSize));
    if (filters.settlementPageNumber) params = params.set('settlementPageNumber', String(filters.settlementPageNumber));
    if (filters.settlementPageSize)  params = params.set('settlementPageSize',  String(filters.settlementPageSize));
    if (filters.monthlyPageNumber)   params = params.set('monthlyPageNumber',   String(filters.monthlyPageNumber));
    if (filters.monthlyPageSize)     params = params.set('monthlyPageSize',     String(filters.monthlyPageSize));
    if (filters.accessorialSortBy)   params = params.set('accessorialSortBy',  filters.accessorialSortBy);
    if (filters.accessorialOrderBy)  params = params.set('accessorialOrderBy', filters.accessorialOrderBy);
    if (filters.settlementSortBy)    params = params.set('settlementSortBy',   filters.settlementSortBy);
    if (filters.settlementOrderBy)   params = params.set('settlementOrderBy',  filters.settlementOrderBy);
    if (filters.monthlySortBy)       params = params.set('monthlySortBy',      filters.monthlySortBy);
    if (filters.monthlyOrderBy)      params = params.set('monthlyOrderBy',     filters.monthlyOrderBy);
    return this.commonHttpService.get<any>(`${this.route}reporting-financial`, params);
  }

  public getAddOnCharges(filters: any): Observable<any> {
    let params = new HttpParams();
    if (filters.timePeriod)    params = params.set('timePeriod',    filters.timePeriod);
    if (filters.startDate)     params = params.set('startDate',     filters.startDate);
    if (filters.endDate)       params = params.set('endDate',       filters.endDate);
    if (filters.pageNumber)    params = params.set('pageNumber',    String(filters.pageNumber));
    if (filters.pageSize)      params = params.set('pageSize',      String(filters.pageSize));
    if (filters.sortBy)        params = params.set('sortBy',        filters.sortBy);
    if (filters.orderBy)       params = params.set('orderBy',       filters.orderBy);
    if (filters.searchKeyword) params = params.set('searchKeyword', filters.searchKeyword);
    if (filters.shipperName)   params = params.set('shipperName',   filters.shipperName);
    if (filters.driverName)    params = params.set('driverName',    filters.driverName);
    if (filters.truckNumber)   params = params.set('truckNumber',   filters.truckNumber);
    if (filters.minAmount !== undefined && filters.minAmount !== '')
                               params = params.set('minAmount',     String(filters.minAmount));
    if (filters.maxAmount !== undefined && filters.maxAmount !== '')
                               params = params.set('maxAmount',     String(filters.maxAmount));
    if (filters.costType !== undefined && filters.costType !== '')
                               params = params.set('costType',      String(filters.costType));
    if (filters.status !== undefined && filters.status !== '')
                               params = params.set('status',        String(filters.status));
    return this.commonHttpService.get<any>(`${this.route}accessorial`, params);
  }
    public getReporting(filters: any): Observable<any> {
    const params = new URLSearchParams();
    if (filters.timePeriod) {
      params.set('timePeriod', filters.timePeriod);
    }
    if (filters.startDate) {
      params.set('startDate', filters.startDate);
    }
    if (filters.endDate) {
      params.set('endDate', filters.endDate);
    }
    if (filters.pageNumber) {
      params.set('pageNumber', filters.pageNumber);
    }
    if (filters.pageSize) {
      params.set('pageSize', filters.pageSize);
    }
    if (filters.sortBy) {
      params.set('sortBy', filters.sortBy);
    }
    if (filters.orderBy) {
      params.set('orderBy', filters.orderBy);
    }
    return this.commonHttpService.get<any>(
      `${this.route}reporting?${params.toString()}`
    );
  }

}
